<template>
   <div :id="id" class="google-map"></div>
</template>
<script>
    import { mapState } from 'vuex'

    const mapZoom = 12;
    export default {
        name: 'google-map',
        //props: ['name'],
        model: {
            prop: 'mapModel',
            event: 'modelChanged'
        },
        props:
            {
                id: {
                    type: String,
                    required: true
                },
                //name: {
                //    type: String,
                //    default: ''
                //},
                mapCenter: null, //{
                   // lat: 51.501527,
                 //   lng: -0.1921837
                //},
                mapVisibility: { default:true },
                mapModel: {
                    //type: Object,
                    default: null
                },
                //stateManager: {
                //    type: Object,
                //    default: null
                //},
                //fromAddress: {
                //    type: [String, Object],
                //    default: ""
                //},
                //toAddress: {
                //    type: [String, Object],
                //    default: ""
                //}
            },
        data: function () {
            return {
                mapName: this.id + "-map",
                map: null,
                markerCoordinates: [],
            }
        },
        mounted: function () {
            const element = document.getElementById(this.id);
            const options = {
                zoom: mapZoom,
                center: new google.maps.LatLng(this.mapCenter.lat, this.mapCenter.lng),
                disableDefaultUI: true,
                //draggable: false,
                //zoomControl: false,
                scrollwheel: false,
                disableDoubleClickZoom: true,
            }
            const map = new google.maps.Map(element, options);
            this.map = map;
            this.markerCoordinates.forEach((coord) => {
                const position = new google.maps.LatLng(this.mapModel.from.location.lat, this.mapModel.from.location.lng);
                const marker = new google.maps.Marker({
                    position,
                    map
                });
            });
        },
        computed: {
            //mapModelComputed: mapState(['bookingInfo.mapInfo'])
            //mapModelComputed: function () {
            //    console.log("map info changed",  this.$store.state.bookingInfo.mapInfo);               
            //    //this.wasChanged = true;
            //    this.mapModel = this.$store.state.bookingInfo.mapInfo;
            //    this.updateMap();
            //},
            //from: function ()  {
            //    console.log("map info from changed", this.$store.state.bookingInfo.mapInfo);
            //   // return this.$store.state.bookingInfo.mapInfo.from;
            //}
        },
        watch: {
            mapModel: function () {
                this.wasChanged = true;
                this.updateMap();
            },
            "mapModel.estimatedDistance": function () {
                console.log("estimated distance changed");
            },
            "mapModel.bookingType": function () {
                this.wasChanged = true;
                this.updateMap();
            },
            mapVisibility: function () {
                if (!this.mapVisibility) return;
                this.updateMap();
            },
            //TODO: remove below condition and use map correctly 
            "mapModel.visible": function () {
                console.log("mapModel.visible changed in map component");
                if (!this.mapModel.visible || !this.wasChanged) return;
                this.updateMap();
            }
        },
        methods: {
            updateMap: function () {
                console.log("update map", this);
                //this.stateManager.setDistanceInfo(0, 0);
                if (!this.mapModel.visible)
                    return;
                //if we have from & to -> get route
                if (this.mapModel && this.mapModel.type == 1 && this.mapModel.from && this.mapModel.to) {
                    this.getRoute();
                }
                else if (this.mapModel && this.mapModel.from && this.mapModel.from.latLng) {
                    this.removeFromMarker();
                    this.setFromMarker();
                }
            },
            setFromMarker() {
                this.fromMarker = new google.maps.Marker({
                    position: this.mapModel.from.latLng,
                    map: this.map
                });
                this.map.setCenter(this.mapModel.from.latLng);
                this.map.setZoom(mapZoom);
                if (this.directionsDisplay) this.directionsDisplay.setMap(null);
            },
            removeFromMarker() {
                if (this.fromMarker) {
                    this.fromMarker.setMap(null);
                    this.fromMarker = null;
                }
            },
            getRoute: function () {
                if (!this.mapModel.visible) return;
                if (!this.directionsService) this.directionsService = new google.maps.DirectionsService();
                if (!this.directionsDisplay) this.directionsDisplay = new google.maps.DirectionsRenderer();
                this.removeFromMarker();
                this.directionsDisplay.setMap(this.map);
                var vm = this;
                var from = this.mapModel.from.address;
                var to = this.mapModel.to.address;
                if (from === to) {
                    from = this.mapModel.from.addressName;
                    to = this.mapModel.to.addressName;
                }
                vm.directionsService.route({
                    origin: from, // Can be coord or also a search query
                    destination: to,
                    travelMode: "DRIVING"
                },
                    function (response, status) {
                        if (status === "OK") {
                            try {
                                var distanceInMeters = response.routes[0].legs[0].distance.value;
                                var timeInSeconds = response.routes[0].legs[0].duration.value;
                                vm.$store.commit('setTimeInMinutes', Math.round(timeInSeconds / 60));
                                vm.$store.commit('setDistanceInMeters', distanceInMeters);
                            } catch (er) {
                                console.log("Directions request failed due to " + er);
                            }
                            vm.directionsDisplay.setDirections(response); // draws the polygon to the map
                        } else {
                            console.log("Directions request failed due to " + status);
                        }
                    });
            }
        }
    };
</script>
<style scoped>
    .google-map {
        width: 100%;
        height: 100%;
        margin: 0 auto;
        background: gray;
    }
</style>